import { React, PropTypes, styled } from '../lib/imports';
import { Text } from '../components';
import ChallengeCard from './ChallengeCard';
import { fireMessageEvent } from '../messenger/utils';
import { useSelector } from 'react-redux';

const PrizeList = styled.ol`
  list-style: none;
  margin: ${({ theme }) => theme.spacings.mega} 0 0;
  padding: 0;
`;

const PrizeItem = styled.li`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }) => theme.spacings.giga};
`;

const PrizeDesc = styled(Text)`
  flex: 1;
  margin-bottom: 0px;
  text-shadow: 0px 4.128px 20.638px rgba(0, 0, 0, 0.49);
`;
const Disclaimer = styled.div`
  text-align: center;
  a {
    color: ${({ theme }) => theme.colors.white};
  }
`;
const Rank = styled.span`
  width: 1.8em;
  height: 1.8em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-image: url('https://cdn.rbi.digital/hockey/icon_badge_gold.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 2px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.black};
  margin-right: ${({ theme }) => theme.spacings.kilo};
`;

const CurrentCard = ({ text, prizes, analyticsTitle, heatStreak, ...props }) => {
  const { config } = useSelector((state) => state);
  const { env, platform } = config;

  const handleDisclaimerClickAnalytics = () => {
    fireMessageEvent({
      platform,
      env,
      title: analyticsTitle,
    });
  };

  const { challengeDisclaimer } = props;

  return (
    <ChallengeCard {...props}>
      {prizes && (
        <PrizeList>
          {prizes.map((prize, i) => (
            <PrizeItem key={i}>
              <Rank>{i + 1}</Rank>
              <PrizeDesc size='giga'>{prize}</PrizeDesc>
            </PrizeItem>
          ))}
        </PrizeList>
      )}
      {heatStreak}
      {analyticsTitle ? (
        <Disclaimer onClick={handleDisclaimerClickAnalytics}>{challengeDisclaimer}</Disclaimer>
      ) : (
        <Disclaimer>{challengeDisclaimer}</Disclaimer>
      )}
    </ChallengeCard>
  );
};

CurrentCard.propTypes = {
  title: PropTypes.string,
  dates: PropTypes.string,
  logosSrc: PropTypes.arrayOf(PropTypes.shape({ src: PropTypes.string, width: PropTypes.string })),
  sponsorText: PropTypes.string,
  prizes: PropTypes.arrayOf(PropTypes.string),
  analyticsTitle: PropTypes.string,
  heatStreak: PropTypes.elementType,
};

export default CurrentCard;
